import React, { memo, lazy, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import RouteElement from '@RootCommon/components/RouteElement'
import { isProd, getEnv } from '@RootCommon/utils'
import AWPENVMAP from '@RootCommon/constants/AWPENVMAP'
import Icon from '@roo/roo/Icon'
import { useTranslation } from '@sailor/i18n-web'
import '@/common/assets/styles/index.less'
import IconLoading from '@RootCommon/components/IconLoading'
import { owlReportMetrics } from '@RootCommon/utils/owl'
// import Loading from '@RootCommon/components/Loading' // <Loading />
// import RooLoading from '@roo/roo/Loading' // <RooLoading visible fullscreen />

const LoadingHtml = IconLoading

// @ts-ignore
Icon.extend({ scriptUrl: [SAILOR_COURIER_PARTNER_ICON_URL] })

// lazy的模块才能使用i18n常量
// appnew
// const Layout = <RouteElement path="*" component={lazy(() => import('@/pagesApp/Layout'))}  />
// const Iframe = <RouteElement path="*" component={lazy(() => import('@/pagesApp/Iframe'))}  />
// const Home = <RouteElement path="*" component={lazy(() => import('@/pagesApp/Home'))} />

const Layout = <RouteElement fallback={LoadingHtml} path="*" component={lazy(() => import('@/components/Layout'))}  />
const Main = <RouteElement fallback={LoadingHtml} path="*" component={lazy(() => import('@/components/Main'))}  />
const Home = <RouteElement path="*" component={lazy(() => import('@/pages/Home'))} />

const App = () => {
  const { t } = useTranslation()
  const { pathname, hash } = location
  if (pathname === '/' && hash !== '') {
    history.pushState({}, '', hash.slice(1))
  }

  const handleOffline = () => {
    owlReportMetrics({ MAIN_GET_OFFLINE: 1 })
  }

  useEffect(() => {
    const AWP_DEPLOY_ENV = process.env.AWP_DEPLOY_ENV
    const SWIMLANE = process.env.SWIMLANE
    const titlePre = AWP_DEPLOY_ENV === 'production' ? '' : `${SWIMLANE || AWPENVMAP[AWP_DEPLOY_ENV] || 'local'}-`
    document.title = `${titlePre}${t('bteam_pc_main_page_title', 'Welcome')}`
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
    <BrowserRouter>
      <RecoilRoot>
        <Routes>
          {/* <Route path="*" element={Layout}>
            <Route path="*" element={Home} />
          </Route>
          <Route path="*" element={Layout}>
            <Route path="home" element={Home} />
          </Route>
          <Route path="/web/*" element={Home} />
          <Route path="home" element={Home} /> */}
          <Route path="/partner/404" element={Home} />
          <Route path="*" element={Layout}>
            <Route path="*" element={Main} />
          </Route>
        </Routes>
      </RecoilRoot>
    </BrowserRouter>
  )
}
export default memo(App)
